import React, { Fragment, useContext } from 'react';
import { ComponentContext } from '../../../context/componentContext';

import CropCard from './CropCard';
import ProductCard from './ProductCard';
import LocationCard from './LocationCard';

const FarmInfo = ({ data }) => {
  const { menuOpen } = useContext(ComponentContext);
  return (
    <Fragment>
      <div className={`flex flex-wrap justify-center ${menuOpen ? 'pl-8 md:pl-24' : ''}`}>
        <div className="w-full md:w-4/5 lg:w-133">
          <div className="bg-cf-300 text-white rounded px-6 py-10 text-center">
            <h4 className="font-semibold">Welcome to your Farm Info!</h4>
            <p className="text-sm md:text-base">Here, you can view informations about your farms</p>
          </div>
        </div>
      </div>
      <div
        className={`flex flex-wrap justify-center px-4 md:px-0 py-10 ${
          menuOpen ? 'pl-8 md:pl-24' : ''
        }`}
      >
        <div className="flex flex-wrap w-full md:w-4/5 lg:w-3/5">
          <ProductCard product={data.product} />
          <LocationCard location={data.product.location} />
          <CropCard crop={data.product.crop} />
        </div>
      </div>
    </Fragment>
  );
};

export default FarmInfo;
